var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox'),
    responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');

function refresh(carousels) {
    carousels.forEach(function (obj) {
        if (responsiveToolkit.is(obj.refreshWhenFontReady)) {
            obj.carousel.trigger('refresh.owl.carousel');
        }
    });
}

function refreshWhenFontReady(carousels) {
    eventToolbox.subscribeCustomEvent('webfont.loaded', function () {
        refresh(carousels);
    });

    /**
     * TODO: find more appropriate solution to redraw only specified carousels,
     * TODO: not all carousels on every deferred css load
     */
    eventToolbox.subscribeCustomEvent('defer-css-loaded', function () {
        refresh(carousels);
    });
}

module.exports = {
    refreshWhenFontReady: refreshWhenFontReady
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/customization/refresh.js
// module id = 43
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17